import React, { useState } from "react";
import Layout from "../../layout/layout";
import fire from "../../../assets/images/sidebar/slots-active.svg";
import info from "../../../assets/images/header/info.svg";
import sgame from "../../../assets/images/home/game-img.svg";
import deadwood from "../../../assets/images/header/deadwood.svg";
import Slider from "react-slick";
import arrow from "../../../assets/images/coins/arrow-left.svg";
import favourite from "../../../assets/images/game/favourite.svg";
import favouriteActive from "../../../assets/images/game/favourite-active.svg";
import fullscreen from "../../../assets/images/game/full-screen.svg";
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import "./slot.css";


const SlotBonanza = () => {
  const[favourites, setfavourites] = useState(false);
  let history = useHistory();
  const handleBack = () => {
    history.push('/slots');
  }

  const handlefavourite = () => {
    setfavourites(!favourites);
    localStorage.setItem("favourite" , true);
    if(favourites){
      localStorage.removeItem("favourite");
    }
  }
  return (
    <Layout>
      <div className="livegames-page bonanza-page">
        <div className="bonanza-game-header">
          <div className="container">
            <div className="bonanza-header">
              <div className="qr-back-arrow" onClick={handleBack}>
                <img src={arrow} alt="" />
                <div className="back-text">
                  <h6>Back</h6>
                  <p>to Slots</p>
                </div>
              </div>
              <div className="right-bonanza-header">
                <div className="demo">
                  Demo
                  <div class="toggle-switch">
                    <input type="checkbox" id="chkTest" name="chkTest" />
                    <label for="chkTest">
                      <span class="toggle-track"></span>
                    </label>
                  </div>
                </div>
                <div className="full-screen" onClick={handlefavourite}>
                  {localStorage.getItem("favourite") ? 
                    <img src={favouriteActive} alt="fullscreen" />
                  : 
                    <img src={favourite} alt="fullscreen" />
                  }
                  Favourite
                </div>
                <div className="full-screen">
                  <img src={fullscreen} alt="fullscreen" />
                  Full Screen
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="start-game">
          <div className="container">
            <img src={sgame} alt="" />
          </div>
        </div>

        <div className="container">
          <div className="games-body">
            <div className="top-games">
              <div className="top-games-heading">
                <h2>
                  <img src={fire} alt=""></img>Similar Slots
                </h2>
              </div>
            </div>

            <ResultSlider />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SlotBonanza;

const ResultSlider = () => {
  // const settings = {
  //   // className: "center",
  //   // centerMode: true,
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   // centerPadding: '150px'
  // };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };



  return (
    <div className="slot-slider">
      <div className="container">
        <div className="slot-slider-content">
          <Slider {...settings}>
            <div className="result-box-grid">
              <div className="result-box">
                <div className="result-sub-box">
                  <img src={deadwood} alt="" />
                </div>
                <div className="info-box">
                  <div className="info-heading">
                    <h6>Deadwood</h6>
                    <p>No Limit City</p>
                  </div>
                  <div className="info-icon">
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={ <Tooltip id="button-tooltip">
                    House Edge: 3.50%
                  </Tooltip>}
                  >
                    <img src={info} alt='info' />
                  </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
            <div className="result-box-grid">
              <div className="result-box">
                <div className="result-sub-box">
                  <img src={deadwood} alt="" />
                </div>
                <div className="info-box">
                  <div className="info-heading">
                    <h6>Deadwood</h6>
                    <p>No Limit City</p>
                  </div>
                  <div className="info-icon">
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={ <Tooltip id="button-tooltip">
                    House Edge: 3.50%
                  </Tooltip>}
                  >
                    <img src={info} alt='info' />
                  </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
            <div className="result-box-grid">
              <div className="result-box">
                <div className="result-sub-box">
                  <img src={deadwood} alt="" />
                </div>
                <div className="info-box">
                  <div className="info-heading">
                    <h6>Deadwood</h6>
                    <p>No Limit City</p>
                  </div>
                  <div className="info-icon">
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={ <Tooltip id="button-tooltip">
                    House Edge: 3.50%
                  </Tooltip>}
                  >
                    <img src={info} alt='info' />
                  </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
            <div className="result-box-grid">
              <div className="result-box">
                <div className="result-sub-box">
                  <img src={deadwood} alt="" />
                </div>
                <div className="info-box">
                  <div className="info-heading">
                    <h6>Deadwood</h6>
                    <p>No Limit City</p>
                  </div>
                  <div className="info-icon">
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={ <Tooltip id="button-tooltip">
                    House Edge: 3.50%
                  </Tooltip>}
                  >
                    <img src={info} alt='info' />
                  </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
            <div className="result-box-grid">
              <div className="result-box">
                <div className="result-sub-box">
                  <img src={deadwood} alt="" />
                </div>
                <div className="info-box">
                  <div className="info-heading">
                    <h6>Deadwood</h6>
                    <p>No Limit City</p>
                  </div>
                  <div className="info-icon">
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={ <Tooltip id="button-tooltip">
                    House Edge: 3.50%
                  </Tooltip>}
                  >
                    <img src={info} alt='info' />
                  </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
            <div className="result-box-grid">
              <div className="result-box">
                <div className="result-sub-box">
                  <img src={deadwood} alt="" />
                </div>
                <div className="info-box">
                  <div className="info-heading">
                    <h6>Deadwood</h6>
                    <p>No Limit City</p>
                  </div>
                  <div className="info-icon">
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={ <Tooltip id="button-tooltip">
                    House Edge: 3.50%
                  </Tooltip>}
                  >
                    <img src={info} alt='info' />
                  </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
            <div className="result-box-grid">
              <div className="result-box">
                <div className="result-sub-box">
                  <img src={deadwood} alt="" />
                </div>
                <div className="info-box">
                  <div className="info-heading">
                    <h6>Deadwood</h6>
                    <p>No Limit City</p>
                  </div>
                  <div className="info-icon">
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={ <Tooltip id="button-tooltip">
                    House Edge: 3.50%
                  </Tooltip>}
                  >
                    <img src={info} alt='info' />
                  </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
};
